import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Stack,
  Divider,
  Grid,
  Box,
  IconButton,
  CircularProgress
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Share, Star, StarBorder } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import './ProfilEntreprise.css';
import HeaderEntreprise from '../../header/headerEntreprise';
import HeaderRec from '../../header/headerRec';
import Footer from '../../commun/Footer';
import DetailItem from '../../commun/DetailItem';

const ProfilVue = () => {
  const userType = localStorage.getItem("userType");
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("authToken");

  const [data, setData] = useState(null);
  const [entrepriseLogo, setEntrepriseLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [favorites, setFavorites] = useState([]);
  const isRecruteurView = true;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { id } = useParams();
  const [recruteurStats, setRecruteurStats] = useState(null);

  useEffect(() => {
    if (!userId || !token) return;
  
    const fetchProfil = async () => {
      try {
        const response = await axios.get(
          `${API_BASE}/api/recruteur/profil/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        const profil = response.data;
  
        setData({
          nomEntreprise: profil.nomEntreprise,
          description: profil.description,
          adresse: profil.adresse,
          secteur: profil.secteur,
          siteWeb: profil.siteWeb,
          effectif: profil.effectif,
          anneeCreation: profil.anneeCreation,
          firstName: profil.utilisateur?.firstName,
          lastName: profil.utilisateur?.lastName,
          email: profil.utilisateur?.email,
          phone: profil.utilisateur?.phone,
          linkedin: profil.linkedin,
          _id: profil._id
        });
  
        setEntrepriseLogo(profil.logo);
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors de la récupération du profil:', error);
        setLoading(false);
      }
    };
  
    // Fetch stats
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/recruteur-stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const statsData = await res.json();
        setRecruteurStats(statsData);
      } catch (err) {
        console.error("Erreur récupération stats recruteur", err);
      }
    };
  
    // Launch both
    fetchProfil();
    fetchStats();
  }, [userId, token]);
  
  if (loading) {
    return (
      <Box textAlign="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography color="error">Impossible de charger le profil.</Typography>
      </Box>
    );
  }

  return (
    <>
      {userType === 'recruteur' ? (
        <HeaderRec userId={userId} authToken={token} />
      ) : (
        <HeaderEntreprise userId={userId} authToken={token} />
      )}

      <main className="pageContainer">
        <div className="contentWrapper">
          <div className="contentGrid">

            {/* Colonne de gauche */}
            <aside className="leftColumn">
              <div className="contactCardContainer">
                <Card className="contact-card-modern">
                  <CardContent>
                    <div className="contact-avatar-container">
                      <Stack direction="column" spacing={1} alignItems="center">
                        <Avatar className="contact-avatar-img">
                          {data.nomEntreprise?.[0]}
                        </Avatar>
                        <Typography variant="h6">
                        {data.firstName} {data.lastName}
                        </Typography>
                      </Stack>
                    </div>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2">
                      <EmailIcon fontSize="small" className="contact-space" /> {data.email || '—'}
                    </Typography>
                    <Typography variant="body2">
                      <PhoneIcon fontSize="small" className="contact-space" /> {data.phone || '—'}
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            </aside>

            {/* Colonne principale */}
            <section className="mainColumn">
              <div className="missionContent">
                <Card className="mission-card-modern">
                  <CardContent>
                    <Box className="mission-header">
                      <Box className="mission-header-left">
                        <Avatar
                          variant="rounded"
                          src={
                            entrepriseLogo
                              ? `${process.env.REACT_APP_API_BASE_URL}${entrepriseLogo}`
                              : undefined
                          }
                          alt={data.nomEntreprise || "Recruteur"}
                          className="logo-avatar"
                        >
                          {data.firstName?.[0]?.toUpperCase() || "R"}
                        </Avatar>

                        <Typography variant="h5" className="mission-title">
                          {data.firstName} {data.lastName}
                        </Typography>
                      </Box>
                    </Box>

                    <Divider className="mission-divider" />

                    <Grid container spacing={2} className="mission-details-grid" sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                      <div className="details-column">
                        <DetailItem
                          label="Nom du recruteur"
                          value={`${data.firstName} ${data.lastName}`}
                        />
                        <DetailItem
                          label="Email du recruteur"
                          value={data.email || '—'}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <div className="details-column">
                        <DetailItem
                          label="Téléphone du recruteur"
                          value={data.phone || '—'}
                        />
                        <DetailItem
                          label="LinkedIn"
                          value={
                            data.linkedin
                              ? <a href={data.linkedin} target="_blank" rel="noopener noreferrer">{data.linkedin}</a>
                              : '—'
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>

                  </CardContent>
                </Card>
              </div>
            </section>

            {/* Colonne de droite */}
            <aside className="sideColumn">
              <div className="talent-card">
                <Stack className="mission-info-header" sx={{ mb: 2 }}>
                  <CardContent>
                  <div className="side-card-value niveau-label-modern">
                    {recruteurStats?.niveau?.label || '-----'}
                  </div>
                  </CardContent>
                </Stack>
              </div>

              <Card className="profil-help-card">
                <CardContent>
                  <Typography variant="h6" className="profil-help-title">
                    Aide sur les actions
                  </Typography>
                  <ul className="profil-help-list">
                    <li>Ajoutez ce recruteur à vos favoris</li>
                    <li>Partagez son profil à un collaborateur</li>
                  </ul>
                </CardContent>
              </Card>
            </aside>

            <aside className="sideColumn"></aside>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default ProfilVue;
